<div>
  <div class="scrollx no-scroll">
    <div
      class="scroll-item padt10"
      *ngFor="let item of retailers"
    >
      <ion-card (click)="navigate(item)" class="ion-no-margin marr10 card-white-background-color">
        <ion-chip *ngIf="item.tag" class="disco-chip tertiary-chip">{{ item.tag }}</ion-chip>
        <img
          [src]="
            item?.img || item?.storeImage || 'https://picsum.photos/id/96/96'
          "
          class="store-img"
        />
        <ion-card-title class="text-wrap title fs-2 font600 card-primary-text-color">{{
          item?.title
        }}</ion-card-title>
        <ion-card-subtitle
        class="card-secondary-text-color fs-1 font400 subtitle" 
          >{{ item?.city || item?.airportData?.city || '' }}, {{ item?.country || item?.airportData?.country || '' }}</ion-card-subtitle
        >
      </ion-card>
    </div>
  </div>
</div>
